const modal = document.querySelector('.pdf-modal')
const html = document.querySelector('html')
const submit = document.querySelector('.pdf-modal__submit')
const btns = document.querySelectorAll('.pdf-uploader')
const radioWrappers = document.querySelectorAll('.pdf-modal__radio');
const closeBtn = document.querySelector('.pdf-modal__close');
const form = document.querySelector('#pdfsForm');
let currentPdfs = {};

if (form) {


    form.addEventListener('submit', (e) => {
        e.preventDefault();

        const selected = form.querySelector('input[name="lang"]:checked');
        if (!selected) return;

        const lang = selected.value;
        const pdf = currentPdfs[lang];

        if (pdf && pdf.url) {
            const link = document.createElement('a');
            link.href = pdf.url;
             link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        modal.classList.remove('active');
        html.classList.remove('hidden');
    });
    closeBtn.addEventListener('click', () => {
        modal.classList.remove('active')
        html.classList.remove('hidden')
    })

    modal.addEventListener('click', (e) => {
        if (!form.contains(e.target)) {
            modal.classList.remove('active');
            html.classList.remove('hidden')
        }
    });

    radioWrappers.forEach(wrapper => {
        wrapper.addEventListener('click', () => {
            const input = wrapper.querySelector('input[type="radio"]');
            if (input) {
                input.checked = true;
            }
        });
    });
}

document.addEventListener('click', (e) => {
    const btn = e.target.closest('.pdf-uploader');
    if (!btn) return;
    currentPdfs = JSON.parse(btn.dataset.pdfs || '{}');
    html.classList.add('hidden')
    modal.classList.add('active');
    radioWrappers.forEach(wrapper => {
        const input = wrapper.querySelector('input[name="lang"]');
        if (!input) return;

        if (currentPdfs[input.value]) {
            wrapper.style.display = 'flex';
        } else {
            wrapper.style.display = 'none';
            input.checked = false;
        }
    });

    const first = Object.keys(currentPdfs)[0];
    if (first) {
        const input = document.querySelector(`input[name="lang"][value="${first}"]`);
        if (input) input.checked = true;
    }
}); 